(function(){
  'use strict';

  function initVp3(root){
    if(!root || root.dataset.vp3Ready === '1') return;
    root.dataset.vp3Ready = '1';

    var sectionEl = root.closest('[id^="shopify-section-"]');
    var sid = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
    var revs = root.querySelectorAll('.vp3-reveal');

    if(window.Shopify && Shopify.designMode){
      revs.forEach(function(el){ el.classList.add('is-vis'); });
    } else if('IntersectionObserver' in window){
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            e.target.classList.add('is-vis');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.04, rootMargin: '0px 0px -20px 0px' });

      revs.forEach(function(el){ obs.observe(el); });
    } else {
      revs.forEach(function(el){ el.classList.add('is-vis'); });
    }

    root.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if(t){
          e.preventDefault();
          t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var zone = root.querySelector('[id^="vp3-upzone-"]');
    var fin = root.querySelector('[id^="vp3-filein-"]');
    var flist = root.querySelector('[id^="vp3-flist-"]');
    var fnames = root.querySelector('[id^="vp3-fn-"]');
    if(!zone || !fin) return;

    var att = [];

    function fmt(b){
      if(b < 1024) return b + ' B';
      if(b < 1048576) return (b / 1024).toFixed(1) + ' KB';
      return (b / 1048576).toFixed(1) + ' MB';
    }

    function esc(s){
      return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function sync(){
      if(fnames){
        fnames.value = att.length ? att.map(function(f){
          return f.name + ' (' + fmt(f.size) + ')';
        }).join(', ') : '';
      }
    }

    function render(){
      if(!flist) return;
      flist.innerHTML = '';

      att.forEach(function(f, i){
        var d = document.createElement('div');
        d.className = 'vp3-upload__file';
        d.innerHTML = '<span>' + esc(f.name) + '</span><span>' + fmt(f.size) + '</span><button type="button" class="vp3-upload__file-rm" data-i="' + i + '" aria-label="Remove">&times;</button>';
        flist.appendChild(d);
      });

      flist.querySelectorAll('.vp3-upload__file-rm').forEach(function(b){
        b.addEventListener('click', function(){
          att.splice(parseInt(b.dataset.i, 10), 1);
          render();
          sync();
        });
      });

      sync();
    }

    function addF(files){
      Array.from(files).forEach(function(f){
        if(f.size > 10 * 1024 * 1024){
          alert(f.name + ' exceeds 10 MB.');
          return;
        }
        att.push(f);
      });
      render();
    }

    zone.addEventListener('dragover', function(e){
      e.preventDefault();
      zone.classList.add('drag-over');
    });

    zone.addEventListener('dragleave', function(){
      zone.classList.remove('drag-over');
    });

    zone.addEventListener('drop', function(e){
      e.preventDefault();
      zone.classList.remove('drag-over');
      addF(e.dataTransfer.files);
    });

    fin.addEventListener('change', function(){
      addF(fin.files);
    });

    var frm = zone.closest('form');
    if(frm){
      frm.addEventListener('submit', function(){
        if(att.length){
          var ta = frm.querySelector('textarea[name="contact[body]"]');
          if(ta && ta.value) ta.value += '\n\n--- Attached files: ' + fnames.value + ' ---';
        }
      });
    }
  }

  function initAll(scope){
    (scope || document).querySelectorAll('.vp3-wrap').forEach(initVp3);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });
})();
